/*
 * Copyright (c) 2025 CalAmp Corp. All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import MapContextMenuLayer from '@ion/dls/src/maps/layers/MapContextMenuLayer';
import {MapContainerProps} from '@ion/dls/src/maps/types/types';
import {setContextMenuLocation} from '../../../../../store/actions/tracking';

/**
 * A smart container component that connects the Map Context Menu layer
 * to the Redux store.
 *
 * - Listens for right-click events on the map view - legacy theme only; the
 *   current theme opens vicinity search from the widget cluster's own
 *   button instead, so it has no map right-click menu.
 * - Dispatches the menu location via `setContextMenuLocation`.
 * - Keeps the presentation and logic layers separate.
 *
 * ```typescript
 * <MapContextMenuLayerContainer map={map} view={view} />
 * ```
 */
export const MapContextMenuLayerContainer = ({
  map,
  view
}: MapContainerProps) => {
  const dispatch          = useDispatch();
  const onContextMenuOpen = useCallback((payload) => {
    dispatch(setContextMenuLocation(payload));
  }, []);

  return (
    <MapContextMenuLayer view={view}
      onContextMenuOpen={onContextMenuOpen} />
  );
};

export default MapContextMenuLayerContainer;
